/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Period_EndInputs */

const en_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Period End`)
};

const fr_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin de la période actuelle`)
};

const de_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende der aktuellen Periode`)
};

const it_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine del periodo corrente`)
};

const ru_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конец текущего периода`)
};

const es_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin del período actual`)
};

const zh_cn2_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本期末`)
};

const ja_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当期末`)
};

const hi_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान अवधि की समाप्ति`)
};

const pt_pt2_period_end = /** @type {(inputs: Period_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do período atual`)
};

/**
* | output |
* | --- |
* | "Current Period End" |
*
* @param {Period_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const period_end = /** @type {((inputs?: Period_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Period_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_period_end(inputs)
	if (locale === "de") return de_period_end(inputs)
	if (locale === "it") return it_period_end(inputs)
	if (locale === "ru") return ru_period_end(inputs)
	if (locale === "es") return es_period_end(inputs)
	if (locale === "zh-CN") return zh_cn2_period_end(inputs)
	if (locale === "ja") return ja_period_end(inputs)
	if (locale === "hi") return hi_period_end(inputs)
	if (locale === "pt-PT") return pt_pt2_period_end(inputs)
	return en_period_end(inputs)
});